import { getText } from '../internal/TextLabels'

export const PaymentMethods = {
  RESURS_CARD: 'RESURS_CARD',
  RESURS_NEW_CARD: 'RESURS_NEW_CARD',
  RESURS_INVOICE: 'RESURS_INVOICE',
  RESURS_PART_PAYMENT: 'RESURS_PART_PAYMENT',
  RESURS_REVOLVING_CREDIT: 'RESURS_REVOLVING_CREDIT',
  RESURS_NEW_REVOLVING_CREDIT: 'RESURS_NEW_REVOLVING_CREDIT',
  RESURS_INVOICE_ACCOUNT: 'RESURS_INVOICE_ACCOUNT',
  RESURS_ZERO: 'RESURS_ZERO',
  SWISH: 'SWISH',
  CARD: 'CARD',
  DEBIT_CARD: 'DEBIT_CARD',
  CREDIT_CARD: 'CREDIT_CARD',
  INTERNET: 'INTERNET',
}

export class PendingApplicationChannel {
  constructor() {
    this.labels = {}

    this.labels['MERCHANT_PORTAL'] = getText(
      'payApply.paymentMethods.pendingChannelType.MerchantPortal',
    )
    this.labels['APPONLINE'] = getText(
      'payApply.paymentMethods.pendingChannelType.Apponline',
    )
  }
}

export const PaymentMethodsStatuses = {
  NOT_ALLOWED_FOR_CUSTOMER: 'NOT_ALLOWED_FOR_CUSTOMER',
  NO_CARD_ON_ACCOUNT: 'NO_CARD_ON_ACCOUNT',
}

export const isRevolvingCredit = paymentMethod => {
  return (
    paymentMethod === PaymentMethods.RESURS_NEW_REVOLVING_CREDIT ||
    paymentMethod === PaymentMethods.RESURS_REVOLVING_CREDIT
  )
}

export const isResursPaymentMethod = type =>
  type === PaymentMethods.RESURS_NEW_CARD ||
  type === PaymentMethods.RESURS_CARD ||
  type === PaymentMethods.RESURS_NEW_REVOLVING_CREDIT ||
  type === PaymentMethods.RESURS_REVOLVING_CREDIT ||
  type === PaymentMethods.RESURS_INVOICE ||
  type === PaymentMethods.RESURS_PART_PAYMENT

export const isEnabledPspPaymentMethod = type =>
  [
    PaymentMethods.SWISH,
    PaymentMethods.CARD,
    PaymentMethods.INTERNET,
    PaymentMethods.DEBIT_CARD,
    PaymentMethods.CREDIT_CARD,
  ].includes(type)

export const isExistingPartPayment = ({ type, availableAccounts = [] }) =>
  type === PaymentMethods.RESURS_PART_PAYMENT && availableAccounts.length > 0

export const isExistingAccountPaymentMethod = paymentMethod =>
  [PaymentMethods.RESURS_CARD, PaymentMethods.RESURS_REVOLVING_CREDIT].includes(
    paymentMethod.type,
  ) || isExistingPartPayment(paymentMethod)
